<template>
    <!-- <button @click="goTo">{{name}}</button> -->
    <!-- <el-button type="primary" icon="el-icon-share" @click="goTo">{{name}}</el-button> -->
    <div class="urlButtonContainer">
        <div class="urlButtonDiv">
            <el-button type="primary" class="urlButton" @click="goTo">{{name}}</el-button>
        </div>
        
    </div>
</template>

<script>
export default {
    props: {config:Object, shared: {type: Boolean, default: false}},
    data(){
        return {
            // id: "cgsTest_" + new Date().getTime()
        }
    },
    mounted (){
    },
    computed:{
        url: {
            get(){
                return this.$props.config.url
            },
            set(){}
        },
        name: {
            get(){
                return this.$props.config.name
            },
            set(){}
        }
    },
    methods:{
      resize(newHPx, newWPx){
        // console.log(newHPx, newWPx)
      },
      goTo(){
          window.open(this.url, '_blank')
      }
    }
    
}
</script>

<style scoped>
.specificComponent{
    width: 100%;
    height: 100%;
    border: 0px;
}
.urlButtonContainer{
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
}
.urlButtonDiv{

}
    
</style>